export function getVbankExpireAfterDays(days) {
    const now = new Date();
    now.setDate(now.getDate() + days);

    return [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0')
    ].join('');
}
